import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { withRouter } from 'react-router-dom';
function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    }
  }, []);

  return (null);
}

const ToTop = withRouter(ScrollToTop);
// import Preloader from "./Preloader";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Transition, TransitionGroup } from "react-transition-group";
import { play, exit } from "./timelines";
import Nav from "./Nav";
import Home from "./views/Home";
import About from "./views/About";
import SocialMedia from "./views/SocialMedia";

import Safety from "./views/Safety";
import Description from "./views/Description";
import SyntheticBiologyWorkshop from "./views/SyntheticBiologyWorkshop";
import ProofOfConcept from "./views/ProofOfConcept";
import Implementation from "./views/Implementation";

import Modeling from "./views/Modeling";
import Contribution from "./views/Contribution";
import Collaborations from "./views/Collaborations";
import UrbanMushroomVisit from "./views/UrbanMushroomVisit";
import Engineering from "./views/Engineering";
import Notebook from "./views/Notebook";
import EducationAndScienceCommunication from "./views/EducationAndScienceCommunication";
import Education from "./views/Education";
import HumanPractices from "./views/HumanPractices";

import Experiment from "./views/Experiments";
import Results from "./views/Results";
import Parts from "./views/Parts";


import Attribution from "./views/Attribution";

import Footer from './Footer';
import Team from './views/Team';
import Comics from './views/Comics';
import Partnership from './views/Partnership';
import Entrepreneurship from './views/Entrepreneurship';
import PublicSurvey from './views/PublicSurvey';
import DoctorInterviews from './views/DoctorInterviews';
import ExpertInterviews from './views/ExpertInterviews';
import Awards from './views/Awards';
gsap.registerPlugin(ScrollTrigger);

const App = () => {
  const progressbarRef = useRef();
  
  useEffect(() => {
    document.getElementById("buttondown").onclick = function () {
      window.scrollTo({
        top: 1000,
        behavior: "smooth"
      });
    }
    gsap.to(".buttondown", {
      opacity: 1,
      ease: "none",
      scrollTrigger: {
        trigger: '.app',
        scrub: 1,
        start: 0,
        end: 100,
        // markers: true
      }
    });

    gsap.to("progress", {
      value: 100,
      ease: "none",
      scrollTrigger: {
        trigger: '.app',
        scrub: 0,
        start: "top",
        
        end: "bottom 100%",
        // markers: true
      }
    });
    
  });
  return (
    <BrowserRouter basename='/cityu-hongkong/'>
      <div className="app">
        <a className="buttondown" id="buttondown" href="#">UP <img src="https://static.igem.wiki/teams/4154/wiki/assets/up-arrow.svg" alt="" /></a>
        <progress
          id="proogressbar"
          ref={progressbarRef}
          max="100"
          value="0"
        ></progress>

        <div className="progress" role="progressbar" >
        </div>

        
        <Route
          render={({ location }) => {
            const { pathname, key } = location;

            return (
              <TransitionGroup component={null}>
                <Transition
                  key={key}
                  // appear={true}
                  onEnter={(node, appears) => {
                    play(pathname, node, appears)
                  }}
                  
                  onExit={(node, appears) => {
                    
                    exit(node, appears)}}
                    
                  timeout={{ enter: 750, exit: 150 }}
                >
                  <>
                  <ToTop/>
                  <Nav />
                  
                  <Switch id="switch" location={location}>
                    
                      <Route exact path="/" component={Home} />
                      <Route path="/safety" component={Safety} />
                      <Route path="/communication" component={EducationAndScienceCommunication} />
                      <Route path="/education" component={Education} />
                      <Route path="/awards" component={Awards} />

                      
                      <Route path="/contribution" component={Contribution} />
                      <Route path="/urban-mushroom-visit" component={UrbanMushroomVisit} />
                      <Route path="/engineering" component={Engineering} />
                      <Route path="/collaborations" component={Collaborations} />
                      <Route path="/model" component={Modeling} />
                      <Route path="/notebook" component={Notebook} />
                      <Route path="/comics" component={Comics} />
                      <Route path="/socialmedia" component={SocialMedia} />
                      <Route path="/synBio" component={SyntheticBiologyWorkshop} />
                      <Route path="/public-survey" component={PublicSurvey} />
                      <Route path="/expert-interviews" component={ExpertInterviews} />
                      <Route path="/doctorinterviews" component={DoctorInterviews} />
                      <Route path="/proof-of-concept" component={ProofOfConcept} />
                      <Route path="/implementation" component={Implementation} />
                      <Route path="/description" component={Description} />
                      <Route path="/attributions" component={Attribution} />
                      
                      <Route path="/experiments" component={Experiment} />
                      <Route path="/results" component={Results} />
                      <Route path="/parts" component={Parts} />
                      <Route path="/partnership" component={Partnership} />
                      <Route path="/entrepreneurship" component={Entrepreneurship} />

                      <Route path="/team" component={Team} />
                      {/* miising pages */}
                      <Route path="/human-practices" component={HumanPractices} />
                  </Switch>
                  <Footer />
                    </>
                </Transition>
              </TransitionGroup>
            );
          }}
        />
      </div>
    </BrowserRouter>
  );
};

export default App;
